export default __webpack_public_path__ + "static/media/logo.0ff5b85e.svg";